import React, { useState, useEffect } from 'react';
import "./Home.scss";

import { BrowserView, MobileView } from "react-device-detect"
import { Container, Row, Col, Table, Badge, Modal, ModalBody } from "reactstrap";
import ReactMarkdown from 'react-markdown';
import { request } from '../../api';

import { Layout, Intro, ImageStack, BetterCarousel } from '../../components'
import { useNavigate } from 'react-router';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const HEADSHOT_PIC = "https://content.noahtemplet.dev/profile_pictures/NoahTHeadshot.jpg"

const PhotoAlbumModal = ({ isOpen, toggle, albumData }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalBody>
        <Container>
          <p className="font-weight-bold text-white">This photo is available in these albums:</p>
          <div className="d-flex flex-column">
            {albumData && albumData.albums && albumData.albums.map(a => (
              <a className="mx-auto" href={`/album/${a.slug}?id=${albumData.photoId}`}>{a.name} <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="lg" /></a>
            ))}
          </div>
        </Container>
      </ModalBody>
    </Modal>
  )
}

export const Home = props => {
  const navigate = useNavigate();

  const [state, setState] = useState({
    loading: false,
    data: null,
    error: null
  })
  const [hideIntro, setIntroHidden] = useState(false)
  const [activeTool, setActiveTool] = useState({
    category: "none",
    tool: -1
  })
  const [activeProject, setActiveProject] = useState(-1)
  const [featured, setFeatured] = useState(null)
  const [loadingFeatured, setLoadingFeatured] = useState(false)
  const [selectedPhotoAlbums, setAlbums] = useState(null)
  const [isOpen, setOpen] = useState(false)

  const checkTimeout = (sec=1) => {
    if(state.loading && !state.data) {
      setTimeout(() => checkTimeout(0.25), sec * 1000)
    } else {
      setIntroHidden(true)
    }
  }

  if(!state.loading && !state.data && !state.error) {
    setState(prevState => ({ ...prevState, loading: true }))

    setTimeout(() => checkTimeout(), 1000)

    request("/photography/public/album", null, "GET")
      .then(res => setState(prevState => ({ ...prevState, loading: false, data: res.data })))
      .catch(err => setState(prevState => ({ ...prevState, loading: false, error: err })))
  }

  if (!featured && !loadingFeatured) {
    setLoadingFeatured(true)

    request("/photography/public/photo/featured", null, "GET")
      .then(res => {
        setFeatured(res.data);
        setLoadingFeatured(false);
      })
      .catch(err => console.log(err))
  }

  const getMaxHeightFromAllPhotos = () => {
    if ((!state.loading && !state.data) | state.loading) return 0;

    return Math.max(...state.data.map(a => 
      Math.max(...a.thumbnails.map(t => t.height))
    ));
  }

  const maxHeight = getMaxHeightFromAllPhotos();

  const showAvailableAlbums = (photoId) => {
    request(`/photography/public/photo/${photoId}/albums`, null, "GET")
      .then(res => {
        setAlbums(res.data);

        setOpen(true);
      })
      .catch(err => console.log(err))
  }
  
  console.log({ featured })

  return (
    <>
      <PhotoAlbumModal isOpen={isOpen} toggle={() => setOpen(!isOpen)} albumData={selectedPhotoAlbums} />
      <Intro hide={hideIntro} loading={state.loading}>
        <Layout>
          {state.data && !state.loading ?
          <>  
            <Container className="mt-4">
              {featured && <Row>
                <Col xs="12">
                  <BetterCarousel photos={featured} openMenu={showAvailableAlbums} />
                </Col>
              </Row>}
              <h1 className="text-white">Albums</h1>
              <Row className="d-flex">
                {state.data.map((album, idx) => (
                  <Col md="4" xs="12" className="d-flex flex-column my-4" onClick={() => navigate(`/album/${album.slug}`)} style={{ cursor: "pointer" }}>
                    <ImageStack
                      key={album.slug}
                      images={album.thumbnails.map(t => t.url)}
                      minHeight={maxHeight}
                      className="mx-auto mb-3"
                      />
                    <h3 className="text-center text-white">{album.name}</h3>
                    <div className="d-flex flex-row justify-content-center">
                    {album.tags.map((tag, i) => (
                      <Badge pill style={{ backgroundColor: '#676767' }} className="ms-1 me-1">
                        {tag.name}
                      </Badge>
                    ))}
                    </div>
                  </Col>
                ))}
              </Row>
            </Container>
          </>
          : <h1>Loading...</h1>}
        </Layout>
      </Intro>
    </>
  )
}

export default Home;